import React from 'react';
import { FaBell, FaCheck, FaExclamationCircle, FaInfoCircle } from 'react-icons/fa';
import { useNotifications } from '../context/NotificationContext';
import { Link } from 'react-router-dom';
import './Notification.css';

const Notification = ({ notification }) => {
  const notificationContext = useNotifications();
  const markAsRead = notificationContext?.markAsRead || (() => {});

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <FaCheck className="notification-icon success" />;
      case 'error':
        return <FaExclamationCircle className="notification-icon error" />;
      case 'info':
        return <FaInfoCircle className="notification-icon info" />;
      default:
        return <FaBell className="notification-icon" />;
    }
  };

  const handleClick = () => {
    if (!notification.read) {
      markAsRead(notification.id);
    }
  };

  const renderContent = () => {
    const content = (
      <div className="notification-content">
        {getIcon(notification.type)}
        <div className="notification-text">
          <p className="notification-message">{notification.message}</p>
          <span className="notification-time">
            {new Date(notification.timestamp).toLocaleString()}
          </span>
        </div>
      </div>
    );

    if (notification.link) {
      return (
        <Link to={notification.link} className="notification-link">
          {content}
        </Link>
      );
    }

    return content;
  };

  return (
    <div 
      className={`notification-item ${notification.read ? 'read' : 'unread'}`}
      onClick={handleClick}
    >
      {renderContent()}
    </div>
  );
};

export default Notification; 